import { BidFormCreationProps } from "@/interfaces/bid_types"
import { z } from "zod";
import { BidFormSchema } from "../Interface/DefaultSchema";

/** Converts the schema to an object that will used to send to the API */
export function formatBidData(data: z.infer<typeof BidFormSchema>, bid_id?: string) {
    const bid_data: BidFormCreationProps = {
        bid_id: bid_id ?? "",
        bid_name: data.bid_name,
        start_date: data.start_date ?? new Date().toISOString(),
        end_date: data.end_date || undefined,
        manager: data.manager?.value ?? "",
        description: data.description ?? "",
        city: data.city?.value ?? "",
        category: data.category?.value ?? "3P",
        status: data.status?.value ?? "Active",
        template: data.template?.value ?? "",
        folder_location: data.folder_location ?? "",
        isDeadline: data.isDeadline,
    }

    return bid_data
}